/**
 * Shared messages used across multiple components
 *
 * Message keys follow the format: formforge.shared.{section}.{element}
 *
 * IMPORTANT: All variables must use ICU Message Format syntax
 *
 * These messages are reused across multiple components - always use these keys
 * instead of creating duplicate entries in component-specific files.
 */
export const sharedMessages = {
  // Actions (used across multiple components)
  Submit: 'formforge.shared.actions.submit',
  'Submitting...': 'formforge.shared.actions.submitting',
  Clear: 'formforge.shared.actions.clear',
  'Close panel': 'formforge.shared.actions.close_panel',
  Close: 'formforge.shared.actions.close',
  'View Requests': 'formforge.shared.actions.view_requests',
  Exit: 'formforge.shared.actions.exit',
  'Refresh Page': 'formforge.shared.actions.refresh',
  'Reload Page': 'formforge.shared.actions.reload',
  'Go to Form Management': 'formforge.shared.actions.go_to_form_management',
  Save: 'formforge.shared.actions.save',
  Publish: 'formforge.shared.actions.publish',
  Preview: 'formforge.shared.actions.preview',
  Cancel: 'formforge.shared.actions.cancel',
  Delete: 'formforge.shared.actions.delete',
  Yes: 'formforge.shared.actions.yes',
  No: 'formforge.shared.actions.no',
  'Back to Forms': 'formforge.shared.actions.back_to_forms',
  Continue: 'formforge.shared.actions.continue',
  Import: 'formforge.shared.actions.import',
  Export: 'formforge.shared.actions.export',
  Share: 'formforge.shared.actions.share',

  // Common Labels
  'Loading...': 'formforge.shared.labels.loading',
  Select: 'formforge.shared.labels.select',
  Name: 'formforge.shared.labels.name',
  Description: 'formforge.shared.labels.description',
  URL: 'formforge.shared.labels.url',
  'Form ID': 'formforge.shared.labels.form_id',
  Tools: 'formforge.shared.labels.tools',
  'Panel settings': 'formforge.shared.labels.panel_settings',
  'Form Name': 'formforge.shared.labels.form_name',
  'Enter form name': 'formforge.shared.labels.enter_form_name',
  'Search SAV Roles...': 'formforge.shared.labels.search_sav_roles',
  Submitting: 'formforge.shared.actions.submitting_loader',
  'Select Category': 'formforge.shared.labels.select_category',

  // Status Messages
  'Submitted:': 'formforge.shared.status.submitted',
  'Request ID:': 'formforge.shared.status.request_id',
  'Orchestration Execution ID:': 'formforge.shared.status.execution_id',

  // Boolean Values
  True: 'formforge.shared.values.true',
  False: 'formforge.shared.values.false',
  '-': 'formforge.shared.values.empty',
  '•': 'formforge.shared.values.bullet',
  'Attribute Mappings ({mapped, number}/{total, number})':
    'formforge.shared.labels.attribute_mappings',
  'Your form is empty. Drag and drop fields to get started.':
    'formforge.shared.labels.empty_form',

  // Loading Messages
  'Loading more data...': 'formforge.shared.loading.loading_more',
  'Loading options...': 'formforge.shared.loading.loading_more_options',
  'Loading editor, please wait...': 'formforge.shared.loading.loading_editor',
  'Loading content, please wait...': 'formforge.shared.loading.loading_content',
  'You have exceeded the maximum character limit':
    'formforge.shared.validation.max_char_exceeded',

  // Error Messages (used across multiple components)
  'Unknown error occurred': 'formforge.shared.errors.unknown',
  'No response data or metadataRef not available for form prefilling':
    'formforge.shared.errors.no_response_data',
  'Form Management': 'formforge.management.header.title',

  // Data Provider Messages
  'The design is subject to change in the final version.':
    'formforge.shared.data_providers.sql.preview_notice',
  'Please select required fields first':
    'formforge.shared.data_providers.select_required_fields_first',
  'This field is required': 'formforge.shared.validation.field_required',

  // Cloudflare Turnstile Messages
  'Cloudflare Turnstile': 'formforge.shared.turnstile.aria_label',
} as const;

// Export type for type safety
export type SharedMessageKey = keyof typeof sharedMessages;
